import { Component, OnInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BrokersService } from '../../services/brokers.service';
import { CompanyService } from 'app/company/services/company.service';
import { Result } from 'app/core/models/result';
import { Router } from '@angular/router';
import { Location, DatePipe } from '@angular/common';
import { CompanyListModel } from 'app/company/models/company-list.model';

@Component({
  selector: 'app-brokers-add',
  templateUrl: './brokers-add.component.html',
  styleUrls: ['./brokers-add.component.css']
})
export class BrokersAddComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    submitAttempt: boolean = false;
    addBrokerFormGroup: FormGroup;
    companyList: CompanyListModel[];

    constructor(
        private brokersService: BrokersService,
        private companyService: CompanyService,
        private fb: FormBuilder,
        private location: Location,
        private router: Router
    ) { }

    ngOnInit() {
        this.headerTitle = {
            title: 'Add Broker', breadcrumbs: [
                { title: 'Brokers', url: ['/brokers'] }
            ]
        }

        this.initializeForm();
    }

    initializeForm(): void {
        this.getAllCompanies();
        this.addBrokerFormGroup = this.fb.group(
            {
                name: ['', Validators.required],
                companyId: ['', Validators.required]
            }
        );
    }

    addBroker(): void {
        this.submitAttempt = true;
        if (this.addBrokerFormGroup.valid) {

            const formValue = this.addBrokerFormGroup.value;
            this.brokersService.create(formValue).subscribe(
                brokerId => {
                    this.router.navigate(['./brokers/']);
                },
                error => {
                    this.errors = (<Result>error).errorList;
                });
        }
    }

    getAllCompanies(): void {
        this.companyService.getAll().subscribe(
            companyList => {
                this.companyList = companyList;
            })
    }

    onBack(): void {
        this.location.back();
    }
}
